export const cols_1= [
  {
    title: "验货单",
    key: "order",
    align: "center",
  },
  {
    title: "入品控仓日期",
    key: "date",
    align: "center"
  },
  {
    title: "类型",
    key: "type",
    align: "center"
  },
  {
    title: "单据状态",
    key: "status",
    align: "center"
  }
  ]

  export const cols_2= [
    {
      title: "验货单",
      key: "inspection_list",
      align: "center"   
    },
    {
      title: "入品控仓日期",
      key: "quality_control_date",
      align: "center"     
    },
    {
      title: "类型",
      key: "type",
      align: "center"
    },
    {
      title: "单据状态",
      key: "order_status",
      align: "center"     
    },
    {
      title: "待检数",
      key: "be_inspected_number",
      align: "center"
    },
    {
      title: "已检数",
      key: "inspected_number",
      align: "center"
    },

  ]